<template>
  <div
    class="bg-image h-100 position-relative overflow-hidden"
    :style="{
      backgroundImage: `url(${backgroundSrc})`,
      backgroundColor: backgroundColor
    }"
    :class="`${backgroundClass}`"
  >
    <div class="container text-start overflow-auto">
      <div class="row py-5">
        <div
          class="mb-3 mb-lg-0"
          :class="{
            col: useInstructions,
            'col-6': !useInstructions
          }"
        >
          <div class="card bg-dark text-light bg-opacity-90 mb-3">
            <div class="card-body p-4">
              <h1 class="card-title">{{ appTitle }}</h1>
              <!-- Main Content -->
              <div>
                <p class="card-subtitle h5 mb-3 mt-2">
                  Go beyond your field of study and gain the skills you need to
                  excel in your next career with OSU Grad Advantage. OSU Grad
                  Advantage provides students a self-assessment tool to gauge
                  their current level in five core competencies and provides
                  opportunities for improvement.
                </p>
              </div>
              <!-- Activity page link, default set to route Main -->
              <div class="text-end">
                <routerLink
                  class="btn btn-lg btn-primary"
                  :to="{ name: callToActionTextDestination }"
                >
                  {{ callToActionText }}
                </routerLink>
              </div>
            </div>
          </div>
          <div v-if="useControls" class="card bg-dark text-light bg-opacity-90">
            <div class="card-body p-4">
              <UserControls />
            </div>
          </div>
        </div>
        <div v-if="useInstructions" class="col">
          <div class="card bg-dark text-light bg-opacity-90">
            <div class="card-body p-4">
              <UserInstructions />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserInstructions from "@/components/ui/UserInstructions.vue";
import UserControls from "@/components/ui/UserControls.vue";
import config from "@/data/config.json";

export default {
  name: "LandingView",
  components: { UserInstructions, UserControls },
  data() {
    return {
      appTitle: config.meta.title,
      // From within the @/assets folder
      // Be aware of file size: Max Size 512kb
      ...config.landingView
    };
  },
  computed: {
    backgroundSrc() {
      if (!this.useBackgroundImg) {
        return;
      }

      return require(`@/assets/${this.backgroundImg}`);
    },
    useBackgroundImg() {
      return this.backgroundImg !== "";
    }
  }
};
</script>
<style scoped>
.bg-image {
  background-size: contain;
  background-position: center bottom;
  background-repeat: no-repeat;
}
.bg-opacity-90 {
  --bs-bg-opacity: 0.9;
}
</style>
